import { useMutation } from '@tanstack/react-query';
import { precheckPartnerLeadContract, type PrecheckPartnerLeadResponse } from '@bliks-io/contracts';
import { apiClient } from '@/api/client';

/**
 * Dedupe gate before appointment selection: checks whether a lead email already
 * exists as a HubSpot contact. Used to block advancing to the Calendly step (so
 * a partner can't book a slot for a contact that already lives in the CRM).
 */
export function usePrecheckPartnerLead() {
  return useMutation({
    mutationFn: async (email: string): Promise<PrecheckPartnerLeadResponse> => {
      const { data } = await apiClient.post<PrecheckPartnerLeadResponse>(
        precheckPartnerLeadContract.path,
        { email }
      );
      return data;
    }
  });
}
